// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase_dev: {
        //change using 'firebase use {project}'
        //run 'npm run-script build' in /angular folder
        //run 'firebase deploy --only hosting:mobile' in /fleet-portal folder


        //spplus-prod
        apiKey: 'AIzaSyDMLCZRrtBucrqdq59025abb4ng0AZcm-o',
        authDomain: 'spplus-prod.firebaseapp.com',
        databaseURL: 'https://spplus-prod.firebaseio.com',
        projectId: 'spplus-prod',

        //aladdin-dev
        //apiKey: 'AIzaSyBs6Mo9FKkYW68jdq-ZsxHyfc6rItZpk7s',
        //authDomain: 'aladdin-dev-3990c.firebaseapp.com',
        //databaseURL: 'https://aladdin-dev-3990c.firebaseio.com',
        //projectId: 'aladdin-dev-3990c',

        storageBucket: '',
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
